module.exports = __webpack_public_path__ + "static/img/peixunBanner.2e6cb01f.png";